import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export type ManageLineDetailsPayload = {
  clubId: string;
  lineQrPath: string;
  lineGroupLink: string;
  lineGroupName: string;
};

const manageLineDetails = (client: AxiosInstance) => async (payload: ManageLineDetailsPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.MANAGE_LINE_DETAILS, payload)).data;
};

export const lineGroupMutations = {
  manageLineDetails,
};
